module.exports = __webpack_public_path__ + "img/INSUFLÁVEIS - AZUL.22a59cdc.svg";